module.exports = __webpack_public_path__ + "img/gal-04.35473ca2.png";